import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
import PointOfSaleCore from "../PointOfSale/Core";
import PointOfSaleRetail from "../PointOfSale/Retail";
import PointOfSaleRestaurant from "../PointOfSale/Restaurant";
import PointOfSaleMarket from "../PointOfSale/Retail/SuperMarket";
import Kiosk from "../PointOfSale/Retail/KioskComponent/index";
import PointOfSaleFashion from "../PointOfSale/Fashion";
import useAuthStore from "../../stores/useAuthStore";
import ModuleGate from "../ModuleGate";

const MobilePOS = React.lazy(() => import("../../mobile"));

function isMobileDevice() {
  // CW Mobile Browser provides a full webview with the bridge — use the real POS
  if (window.electronAPI) return false;
  if (window.__CW_MOBILE_BROWSER__) return true;
  const ua = navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod/i.test(ua) && !/Electron/i.test(ua);
}

const PointOfSale = () => {
  const tillData = useAuthStore((s) => s.tillData);
  if (!tillData?.tillAccess) {
    console.warn("[AUTH-DIAG] PointOfSale → no tillAccess, redirecting to /till", {
      hasTillData: !!tillData,
      tillDataKeys: tillData ? Object.keys(tillData) : [],
    });
    return <Redirect to="/till" />;
  }

  const tillaccess = tillData.tillAccess.userAccessController ? JSON.parse(tillData.tillAccess.userAccessController) : {};
  const tillLayout = parseInt(tillaccess?.layout ?? 1);

  // ModuleGate now covers the mobile branch too — previously isMobileDevice() returned
  // before the tillaccess.pos check ran, letting mobile users bypass permission entirely.
  return (
    <ModuleGate module="pos">
      {isMobileDevice() ? (
        <Suspense fallback={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100dvh" }}>Loading...</div>}>
          <MobilePOS />
        </Suspense>
      ) : (
        <PointOfSaleCore component={tillLayout === 1 ? PointOfSaleRetail : tillLayout === 3 ? Kiosk : tillLayout === 4 ? PointOfSaleMarket : tillLayout === 5 ? PointOfSaleFashion : PointOfSaleRestaurant} />
      )}
    </ModuleGate>
  );
};

export default PointOfSale;
